export default "__VITE_ASSET__5a0b9f77__"